<script lang="ts">
  import Card from '../Card.svelte';
  import PostCardContent from './PostCardContent.svelte';
  import PostCardImageContent from './PostCardImageContent.svelte';

  export let post: any;

  export let user: string;

  export let cardUrl = '/tools/blog/posts/';
</script>

<Card cardUrl={`${cardUrl}${post.slug}`} title={post.title.rendered}>
  <PostCardImageContent slot="card-image" {post} />
  <PostCardContent slot="card-text" {post} {user} />
</Card>
